import { cloneElement } from 'react';
import styled from 'styled-components';

const createStyledComponent = (() => {
    const cache = new Map();
    return (type, styles) => {
        if (!cache.has(type)) {
            cache.set(type, new Map());
        }
        if (!cache.get(type).has(styles)) {
            cache.get(type).set(styles, styled(type)`${styles}`);
        }
        return cache.get(type).get(styles);
    };
})();

export default function cloneElementWithStyles(element, styles, config, children) {
    const styledComponent = createStyledComponent(element.type, styles);
    const styledElement = {
        ...element,
        type: styledComponent,
    };
    return cloneElement(styledElement, config, children || element.props.children);
}
